const onboardingService = require("../../../../services/onboard")
const FV = require('../../../components/form-validation/form-validation.script');
const options = require('./data/options');
var donations = [];

export async function load() {

    // add a click event to addItemBtn
    document
        .getElementById("addItemBtn")
        .addEventListener('click', (e) => {
            addItem()
        })

    // add event click to cadastrarNecessidades
    document.getElementsByName("cadastrarNecessidades")
        .forEach((selTipoEl) => {
            selTipoEl.addEventListener('click', (_e) => {
                switchForm(selTipoEl.value)
            })
        })


    try {
        //add first form element
        addItem()
        switchForm("false")
        startForm(document.getElementById("etapa_5"))

        return true
    } catch (err) {
        console.log('err', err)
        return err
    }
}


async function switchForm(type) {

    const itemContainer = document.getElementById("itemsContainer")
    if (type == 'true') {

        itemContainer
            .classList.remove("disabled")

        Array.from(itemContainer
            .getElementsByTagName("textarea"))
            .forEach((el) => {
                el.disabled = false
            })

        Array.from(itemContainer
            .getElementsByTagName("input"))
            .forEach((el) => {
                el.disabled = false
            })
    } else {
        itemContainer
            .classList.add("disabled")


        Array.from(itemContainer
            .getElementsByTagName("textarea"))
            .forEach((el) => {
                el.disabled = true
            })

        Array.from(itemContainer
            .getElementsByTagName("input"))
            .forEach((el) => {
                el.disabled = true
            })
    }
}

function addItem() {

    const itemsContainer = document.getElementById("itemsContainer");
    const userType = document.getElementById('etapa_5').getAttribute('userType');

    const UUID = uuidv4()

    var item = `
  <donation-item id="${UUID}">
      <div class="label-float">
      <inputBox field="description_${UUID}" type="textarea" isRequired="true" inputType="textarea" friendlyName="Descrição">
            <textarea  id="description_${UUID}" name="description" cols="30" rows="10" placeholder="${options[userType].messagePlaceholder}"></textarea>

              <errorMessage>Este campo é obrigatório para prosseguir</errorMessage>
          </inputBox>
      </div>
      <div class="upload-fotos">
          <div class="drop-imgs">
            <inputBox field="image_${UUID}" type="image_${UUID}" isRequired="true" inputType="file" friendlyName="Imagem">
                <input type="file" accept="image/*" name="ongPictures" class="ongPictures" id="selectFile_${UUID}">

              <label for="ongPictures">
                  <img alt="Selecione uma imagem para seu item" src="./images/icons/cam.svg"> <placeholder>Selecione uma imagem para seu item
                    </placeholder>

                    <span class="delete-icon d-none">
                        <placeholder>Deletar item</placeholder> <img alt="Deletar item" src="./images/icons/trash-icon.svg">
                    </span>
                </label>
              <errorMessage>Este campo é obrigatório para prosseguir</errorMessage>
            </inputBox>
          </div>
          <div id="upload_list"></div>
      </div>
    </donation-item>`
    var donationObject = {
        id: UUID,
        description: "",
        image: null
    }
    donations.push(donationObject)
    itemsContainer.innerHTML += item;

    updateEventListener()
}

function updateEventListener() {
    Array.from(document.getElementsByTagName("donation-item"))
        .forEach((el, i) => {
            var UUID = el.getAttribute('id')
            var descriptionEL = el.getElementsByTagName('textarea')[0]
            var fileEl = el.getElementsByTagName('input')[0]
            var labelEl = el.getElementsByTagName('label')[0]

            descriptionEL.value = getDonationByID(UUID).description
            descriptionEL.addEventListener("keyup", (e) => updateFormValue(descriptionEL.value, UUID))
            fileEl.addEventListener("change", (e) => changeFile(e, UUID), true)
            var placeholderEl = el.getElementsByTagName('placeholder')[0]

            var deleteIcon = el.querySelector('.delete-icon');

            if (deleteIcon.classList.contains('d-none')) {
                deleteIcon.classList.remove('d-none');
                deleteIcon.setAttribute('id', UUID);
            }

            deleteIcon.addEventListener('click', function (evt) {
                const uniqueId = evt.target.getAttribute('id');
                const index = donations.findIndex((value) => value.id == uniqueId);

                if (index != -1) {

                    const documents = document.querySelectorAll(`donation-item`);

                    console.info(`Removed:  donation-item["id"="${uniqueId}"]`);

                    donations.splice(index, 1)

                    documents[index].remove();
                }
            });

            if (getDonationByID(UUID).image && getDonationByID(UUID).image.name) {

                fileEl.files = getDonationByID(UUID).originalFileList;

                placeholderEl.innerHTML = getDonationByID(UUID).image.name
                el.getElementsByTagName('img')[0].url = window.URL.createObjectURL(getDonationByID(UUID).image)



                if (!fileEl.classList.contains('has-file')) {
                    fileEl.classList.add('has-file');
                }

                if (!labelEl.classList.contains('has-file')) {
                    labelEl.classList.add('has-file');
                }
            }

        });
}


function updateFormValue(value, id) {
    var donation = donations.find((donation) => {
        return donation.id == id;
    })
    console.log('donation', donation)
    if (donation) {
        donation.description = value;
    }
}

function changeFile(e, id) {
    getDonationByID(id).originalFileList = e.srcElement.files;
    getDonationByID(id).image = e.srcElement.files[0];
    updateEventListener()
}


function getDonationByID(id) {
    var donation = donations.find((donation) => {
        return donation.id == id;
    })
    return donation
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function generateFormData() {

    var formData = new FormData();

    donations.forEach((donation, index) => {
        Object.keys(donation).forEach((key, i) => {
            if (key != 'originalFileList') {
                if (Object.keys(donation) == 'file') {
                    formData.append(`donation_item[${index}][${key}]`, donation[key], donation[key].name);
                } else {
                    formData.append(`donation_item[${index}][${key}]`, donation[key]);
                }
            }
        });

    });

    return formData


}



function startForm(formEl) {
    formEl
        .addEventListener('submit', function (evt) {
            evt.preventDefault()
            FV.clearErrosMessages(formEl)
            sendForm(formEl)
        })
}


async function sendForm(formEl) {
    const userID = formEl.getAttribute("userID");
    const userType = formEl.getAttribute("userType")
    const formValues = await FV.getFormValues(formEl);

    if (formValues.cadastrarNecessidades == "true") {
        if (FV.thisFormIsValid(formEl)) {
            const formData = generateFormData()

            const button = document.getElementById('sendButton');

            if (!button.classList.contains('loading')) {
                button.classList.add('loading');
            }

            try {
                let saved;
                if (userType != 'ong') {
                    saved = await onboardingService.donation(formData, userID)
                } else {
                    saved = await onboardingService.request(formData, userID)
                }
                window.barba.go(`/cadastro/etapa_6/${userID}`);

                if (button.classList.contains('loading')) {
                    button.classList.remove('loading');
                }
            } catch (err) {
                if (button.classList.contains('loading')) {
                    button.classList.remove('loading');
                }
                alert(err)
            }
        }
    } else {
        window.barba.go(`/cadastro/etapa_6/${userID}`);
    }

}
